import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, parentTexts } from 'consts/text';
import { getErrorMessageAndCode } from '../getErrorMessageAndCode';

export const groupAttendanceMonthlyErrorParser: (
    error: unknown,
    defaultErrorMessage?: string,
) => string = (error, defaultErrorMessage = commonTexts.errorMessages.unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.DATE_OUTSIDE_JOURNAL) {
        return parentTexts.groupAttendance.table.dateOutsideJournalErrorMessage;
    }

    return defaultErrorMessage;
};
